<i18n src="@/locales/views/home_app.yml" lang="yaml"></i18n>
<template>
  <div>
    <agro-exporter-dashboard v-if="user_is_agro_exporter" />
  </div>
</template>

<script>
import AgroExporterDashboard from "@/components/views/dashboard/AgroExporter.vue";
export default {
  name: "HomeApp",
  components: { AgroExporterDashboard },
  computed: {
    user_name() {
      return this.$store.state.user.user_full_name;
    }
  },
  created() {
    this.checkIfAuthenticated();
  }
};
</script>
